.list {
  padding: 0;
  list-style: none;
}

.item {
  padding: 16px 0;
  overflow-wrap: anywhere;
  border-bottom: 1px solid var(--ant-color-border);
}

.item p {
  margin: 8px 0 0;
}

.score {
  margin: 16px 0;
  font-weight: 600;
}
